import { PromptItem } from './types';

export const defaultPrompts: PromptItem[] = [
  { 
    id: 1, 
    title: "Expand to Wide View", 
    prompt: "Create an expanded image with extended space.",
    titleZh: "扩展到宽视图",
    promptZh: "创建一个具有扩展空间的扩展图像。"
  },
  { 
    id: 2, 
    title: "Zoom into Detail", 
    prompt: "Create a micro-detail close-up focus variant.",
    titleZh: "放大到细节",
    promptZh: "创建一个微观细节特写聚焦变体。"
  },
  { 
    id: 3, 
    title: "Switch to Paper Cut", 
    prompt: "Create this picture as a modern paper cut, with layered colors and soft shadows.",
    titleZh: "切换到剪纸风格",
    promptZh: "将这张图片制作成现代剪纸风格，具有分层的颜色和柔和的阴影。"
  },
  { 
    id: 4, 
    title: "Switch to Embroidery", 
    prompt: "Create this picture as a textile embroidery, with visible stitched threads.",
    titleZh: "切换到刺绣风格",
    promptZh: "将这张图片制作成纺织刺绣风格，具有可见的缝制线条。"
  },
  { 
    id: 5, 
    title: "Change to Pixel Art", 
    prompt: "Create this picture as a retro pixel art, with nostalgic detail and game shading.",
    titleZh: "改为像素艺术",
    promptZh: "将这张图片制作成复古像素艺术，具有怀旧细节和游戏阴影。"
  },
  { 
    id: 6, 
    title: "Apply Glitch Effect", 
    prompt: "Create this picture as a glitch digital art, with pixel splits and cyberpunk noise.",
    titleZh: "应用故障效果",
    promptZh: "将这张图片制作成故障数字艺术，具有像素分裂和赛博朋克噪点。"
  },
  { 
    id: 7, 
    title: "Change to Watercolor", 
    prompt: "Create this picture as a watercolor painting.",
    titleZh: "改为水彩画",
    promptZh: "将这张图片制作成水彩画。"
  },
  { 
    id: 8, 
    title: "Change to Impressionism", 
    prompt: "Create this picture as an Impressionist painting, with loose brushwork, luminous color, and fleeting light.",
    titleZh: "改为印象派风格",
    promptZh: "将这张图片制作成印象派绘画，具有松散的笔触、明亮的色彩和瞬息万变的光线。"
  },
  { 
    id: 9, 
    title: "Use Colored Pencil", 
    prompt: "Create this picture as a colored pencil drawing.",
    titleZh: "使用彩色铅笔",
    promptZh: "将这张图片制作成彩色铅笔画。"
  },
  { 
    id: 10, 
    title: "Switch to Fine-line", 
    prompt: "Create this picture as a Chinese Gongbi painting, with precise outlines, soft washes, and detailed forms.",
    titleZh: "切换到工笔画",
    promptZh: "将这张图片制作成中国工笔画，具有精确的轮廓、柔和的渲染和细致的形态。"
  },
  { 
    id: 11, 
    title: "Switch to Chinese Paper Cut", 
    prompt: "Create this picture as a Chinese paper cut, with red silhouettes, cultural motifs, and symmetrical patterns.",
    titleZh: "切换到中国剪纸",
    promptZh: "将这张图片制作成中国剪纸，具有红色剪影、文化图案和对称图案。"
  },
  { 
    id: 12, 
    title: "Apply Ukiyo-e Style", 
    prompt: "Create this picture as a Japanese Ukiyo-e, with woodblock texture, flat colors, and flowing lines.",
    titleZh: "应用浮世绘风格",
    promptZh: "将这张图片制作成日本浮世绘，具有木版纹理、平面色彩和流畅线条。"
  },
  { 
    id: 13, 
    title: "Change to Portrait", 
    prompt: "Create this picture as a photo portrait, with natural light, and shallow depth.",
    titleZh: "改为肖像照",
    promptZh: "将这张图片制作成肖像照片，具有自然光线和浅景深。"
  },
  { 
    id: 14, 
    title: "Use Stained Glass", 
    prompt: "Create this picture as a stained glass design, with colorful panes, bold outlines, and glowing light.",
    titleZh: "使用彩色玻璃",
    promptZh: "将这张图片制作成彩色玻璃设计，具有彩色玻璃片、粗体轮廓和发光效果。"
  },
  { 
    id: 15, 
    title: "Apply Silkscreen Style", 
    prompt: "Create this picture as a silkscreen print.",
    titleZh: "应用丝网印刷风格",
    promptZh: "将这张图片制作成丝网印刷。"
  },
  { 
    id: 16, 
    title: "Switch to Anime Look", 
    prompt: "Create this picture as an anime illustration, with expressive light, dynamic layout.",
    titleZh: "切换到动漫风格",
    promptZh: "将这张图片制作成动漫插画，具有富有表现力的光线和动态布局。"
  },
  { 
    id: 17, 
    title: "Add Sepia Tone", 
    prompt: "Create this picture as a sepia-toned memory with aged paper texture.",
    titleZh: "添加复古色调",
    promptZh: "将这张图片制作成带有陈旧纸张纹理的复古色调记忆。"
  },
  { 
    id: 18, 
    title: "Change to Pop Art", 
    prompt: "Create this picture as a high-saturation pop art, with bold blocks and hues.",
    titleZh: "改为波普艺术",
    promptZh: "将这张图片制作成高饱和度的波普艺术，具有大胆的色块和色调。"
  },
  { 
    id: 19, 
    title: "Apply Gradient Mesh", 
    prompt: "Create this picture as a gradient mesh, blending colors seamlessly across the composition.",
    titleZh: "应用渐变网格",
    promptZh: "将这张图片制作成渐变网格，在整个构图中无缝融合颜色。"
  },
  { 
    id: 20, 
    title: "Render as 3D Figure", 
    prompt: "Create this picture as a photorealistic 3D render of a collectible figure, made of real materials like resin or plastic, with cinematic lighting, studio backdrop, and ultra-fine modeling detail.",
    titleZh: "渲染为3D模型",
    promptZh: "将这张图片制作成逼真的3D渲染收藏模型，使用真实材料如树脂或塑料，具有电影级照明、工作室背景和超精细建模细节。"
  },
  { 
    id: 21, 
    title: "Use Duotone Colors", 
    prompt: "Create this picture as a duotone image.",
    titleZh: "使用双色调",
    promptZh: "将这张图片制作成双色调图像。"
  },
  { 
    id: 22, 
    title: "Convert to Monochrome", 
    prompt: "Create this picture as a monochrome image.",
    titleZh: "转换为单色",
    promptZh: "将这张图片制作成单色图像。"
  },
  { 
    id: 23, 
    title: "Add Neon Lighting", 
    prompt: "Create this picture as a neon-lit scene, with vibrant color contrasts.",
    titleZh: "添加霓虹灯光",
    promptZh: "将这张图片制作成霓虹灯照明场景，具有鲜明的色彩对比。"
  },
  { 
    id: 24, 
    title: "Make Mechanical", 
    prompt: "Create a mechanical version of the subject with exposed gears, metallic joints, and precision components.",
    titleZh: "制作机械版本",
    promptZh: "创建主体的机械版本，具有暴露的齿轮、金属接头和精密组件。"
  },
  { 
    id: 25, 
    title: "Turn into Crystal", 
    prompt: "Create an iridescent fantasy realm with the subject as translucent glass or crystal, glowing and refracted.",
    titleZh: "转为水晶风格",
    promptZh: "创建一个彩虹色的幻想境界，将主体制作成半透明的玻璃或水晶，具有发光和折射效果。"
  },
  { 
    id: 26, 
    title: "Change the subject", 
    prompt: "(Fill in the subject you want to change to.)",
    titleZh: "更改主题",
    promptZh: "（填入您想要更改的主题）"
  }
];

// Utility functions for prompt management
export const shuffleArray = <T>(array: T[]): T[] => {
  const shuffled = [...array];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
};

export const getRandomPrompts = (prompts: PromptItem[], count: number = 3): PromptItem[] => {
  const shuffled = shuffleArray(prompts);
  return shuffled.slice(0, Math.min(count, prompts.length));
};

export const getRandomReplacement = (
  allPrompts: PromptItem[], 
  currentPrompts: PromptItem[], 
  excludeId: number
): PromptItem | null => {
  const currentIds = currentPrompts.map(p => p.id);
  const available = allPrompts.filter(p => !currentIds.includes(p.id) || p.id === excludeId);
  
  if (available.length === 0) return null;
  
  const shuffled = shuffleArray(available);
  return shuffled[0];
};

export const searchPrompts = (prompts: PromptItem[], query: string, language: 'en' | 'zh' = 'en'): PromptItem[] => {
  if (!query.trim()) return prompts;
  
  const lowerQuery = query.toLowerCase();
  return prompts.filter(p => {
    if (language === 'zh') {
      const titleZh = p.titleZh || p.title;
      const promptZh = p.promptZh || p.prompt;
      return titleZh.toLowerCase().includes(lowerQuery) || 
             promptZh.toLowerCase().includes(lowerQuery) ||
             p.title.toLowerCase().includes(lowerQuery) ||
             p.prompt.toLowerCase().includes(lowerQuery);
    } else {
      return p.title.toLowerCase().includes(lowerQuery) || 
             p.prompt.toLowerCase().includes(lowerQuery);
    }
  });
};